import React from 'react';
import { Link } from 'react-router-dom';
import GradientText from './reactbits/GradientText/GradientText';
import ShinyText from './reactbits/ShinyText/ShinyText';
import Reveal from './ui/Reveal';

const ArticlesBreadcrumbs = ({
  title = 'Insights, Ideas & Innovations',
  tagline = 'Articles',
}) => (
  <section className="breadcrumbs">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <div className="breadcrumb-wrapper">
            <Reveal className="breadcrumb-cnt" delay={0.06}>
              <span>
                <GradientText as="span" className="nalexus-heading-gradient" animationSpeed={12}>
                  {tagline}
                </GradientText>
              </span>
              <h1>
                <ShinyText
                  text={title}
                  className="nalexus-heading-shine"
                  color="#f1ede3"
                  shineColor="#ffd369"
                  speed={2.6}
                />
              </h1>

              <div className="breadcrumb-list">
                <Link to="/">Home</Link>
                <img src="/assets/img/content/breadcrumb-arrow.svg" alt="" />
                {tagline}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default ArticlesBreadcrumbs;





